// cryptoUtil.ts
import CryptoJS from "crypto-js";

const SECRET_KEY = `${process.env.REACT_APP_SECRET_KEY}`

// Encrypt sensitive data
export const encryptData = (data: string) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};

// Decrypt sensitive data
export const decryptData = (encryptedData: string) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
